import { ChangeDetectionStrategy, Component, HostBinding, Inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PDF_DATA } from '@vsolv/packages/pdf/web';
import { Config } from '@vsolv/packages/portal-config/domain';
import { Warranty } from '@wsphere/warranties/domain';
import { map } from 'rxjs';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'ws-warranty-pdf',
  templateUrl: './warranty-pdf.component.html',
  standalone: false,
})
export class WarrantyPDFComponent {
  @HostBinding('class') protected _class = 'block h-[100vh]';

  protected readonly config$ = this.route.parent?.data.pipe(map(data => data['config'] as Config.PortalConfig));
  protected readonly today = new Date();

  constructor(
    @Inject(PDF_DATA) public warranty: Warranty.PDFData,
    private route: ActivatedRoute
  ) {}
}
